import { createTokens } from 'tamagui'

import {
  backgroundColors,
  borderColors,
  brandColors,
  commonColors,
  foregroundColors,
  functionalColors,
} from './colors'

export const size = {
  0: 0,
  0.25: 2,
  0.5: 4,
  0.75: 8,
  1: 20,
  1.5: 24,
  2: 28,
  2.5: 32,
  3: 36,
  3.5: 40,
  4: 44,
  true: 44,
  4.5: 48,
  5: 52,
  5.5: 56,
  6: 64,
  7: 74,
  7.5: 80,
  8: 84,
  9: 94,
  10: 104,
  11: 124,
  12: 144,
  13: 164,
  14: 184,
  15: 204,
  16: 224,
  17: 224,
  18: 244,
  19: 264,
  20: 284,
  21: 304,
  22: 324,
  23: 344,
  24: 364,
  25: 384,
  26: 404,
}

type Sizes = typeof size
type SizeKeys = `${keyof Sizes}`

const spaces = [
  ['0', 0],
  ['0.25', 1],
  ['0.5', 1],
  ['0.75', 3],
  ['1', 2],
  ['1.5', 4],
  ['2', 8],
  ['2.5', 10],
  ['3', 12],
  ['3.5', 16],
  ['4', 18],
  ['4.5', 20],
  ['5', 24],
  ['6', 32],
  ['7', 40],
  ['8', 46],
  ['8.5', 48],
  ['9', 54],
  ['9.5', 56],
  ['10', 60],
  ['10.5', 62],
  ['11', 74],
  ['12', 88],
  ['13', 102],
  ['14', 116],
  ['15', 130],
  ['16', 144],
  ['17', 144],
  ['18', 158],
  ['19', 172],
  ['20', 186],
  ['true', 18],
] as const

const spacesNegative = spaces.map(([k, v]) => [`-${k}`, -v])

export const space: {
  [Key in `-${SizeKeys}` | SizeKeys]: Key extends keyof Sizes
    ? Sizes[Key]
    : number
} = {
  ...Object.fromEntries(spaces),
  ...Object.fromEntries(spacesNegative),
} as any

export const zIndex = {
  0: 0,
  1: 100,
  2: 200,
  3: 300,
  4: 400,
  5: 500,
  6: 600,
}

export const color = {
  ...brandColors,
  ...backgroundColors,
  ...foregroundColors,
  ...borderColors,
  ...functionalColors,
  ...commonColors,
}

export const radius = {
  0: 0,
  1: 3,
  2: 5,
  3: 7,
  4: 9,
  5: 10,
  6: 16,
  7: 19,
  8: 22,
  9: 26,
  10: 34,
  11: 42,
  12: 50,
  pill: 1000, // Pill-shaped buttons
}

export const tokens = createTokens({
  color,
  radius,
  zIndex,
  space,
  size,
})
